import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';

import { ContainerHeader, TabContainer } from '~components';
import { faMoneyBill } from '~components/icon';

import { getFeatureFlag } from '~main/actions/login';

import { Claims, Contributions, Reconciliations, Statements } from './index';

const ClaimsContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const [showStatements, setShowStatements] = useState(false);

  const tabs = [
    { id: 'sah-claims', title: 'Claims', component: Claims },
    { id: 'sah-claims-reconciliations', title: 'Reconciliations', component: Reconciliations },
    { id: 'sah-claims-contributions', title: 'Contributions', component: Contributions },
  ];

  if (showStatements) {
    tabs.push({ id: 'sah-claims-statements', title: 'Statements', component: Statements });
  }

  useEffect(() => {
    checkStatementPermissions();
  }, []);

  const checkStatementPermissions = async () => {
    const { payload } = await dispatch(getFeatureFlag({ flag: 'feature-sah-statements' }));
    setShowStatements(payload?.data ?? false);
  };

  return (
    <div className="p-2">
      <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="sah-claims-header">
        <div className="d-flex align-items-center gap-1">
          <span>Support At Home Claims</span>
        </div>
      </ContainerHeader>
      <TabContainer tabs={tabs} />
    </div>
  );
};

export default ClaimsContainer;
